import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { TranslationModule } from '@hdms/shared/feature';
import { HeaderEditorialMenuLinksModule, HeaderProductMenuLinksModule } from '@hdms/shared/page-frame/ui';
import {
  ButtonModule,
  FlyoutModule,
  MobileModalWindowModule,
  NavButtonModule,
  SmartbarModule,
  SvgIconModule
} from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderMegaMenuItemComponent } from './header-mega-menu-item/header-mega-menu-item.component';
import { HeaderMegaMenuComponent } from './header-mega-menu.component';

@NgModule({
  declarations: [HeaderMegaMenuComponent, HeaderMegaMenuItemComponent],
  exports: [HeaderMegaMenuComponent, HeaderMegaMenuItemComponent],
  imports: [
    ButtonModule,
    CommonModule,
    FlyoutModule,
    NgbPopoverModule,
    MobileModalWindowModule,
    NavButtonModule,
    HeaderProductMenuLinksModule,
    HeaderEditorialMenuLinksModule,
    AnalyticsModule,
    SmartbarModule,
    SvgIconModule,
    TranslationModule
  ]
})
export class HeaderMegaMenuModule {}
